import React from "react";
import {
  Modal,
  Typography,
  Avatar,
  Space,
  Row,
  Col,
  Divider,
} from "antd";
import {
  UserOutlined,
  MailOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./ProfilePopup.css";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useResponsiveLayout } from "./hooks/useResponsiveLayout";

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

interface ProfilePopupProps {
  visible: boolean;
  onClose: () => void;
  user?: any;
}

const ProfilePopup: React.FC<ProfilePopupProps> = ({
  visible,
  onClose,
  user,
}) => {
  const { Title } = Typography;
  const { isMobile } = useResponsiveLayout();

  return (
    <Modal
      title={<Title level={4}>Profile Information</Title>}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={isMobile ? '95%' : 600}
      style={{ maxWidth: isMobile ? '95vw' : '600px' }}
      className="profile-modal"
    >
      <Space orientation="vertical" size="large" style={{ width: "100%" }}>
        <Row gutter={isMobile ? 8 : 16} align="middle">
          <Col xs={24} sm={8} md={8}>
            <Avatar
              size={64}
              icon={<UserOutlined />}
              className="profile-avatar"
            />
          </Col>
          <Col xs={24} sm={16} md={16}>
            <Typography.Title level={4} className="profile-name">
              {user?.first_name || "User"}
            </Typography.Title>
          </Col>
        </Row>

        <Divider />

        <Row gutter={isMobile ? 8 : 16}>
          <Col xs={24} sm={12} md={12}>
            <div className="profile-field">
              <MailOutlined className="profile-icon" />
              <span className="profile-label">Email</span>
              <Typography.Text>
                {user?.email || "Not Available"}
              </Typography.Text>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <div className="profile-field">
              <ClockCircleOutlined className="profile-icon" />
              <span className="profile-label">Last Login</span>
              <Typography.Text>
                {user?.last_login
                  ? dayjs(user.last_login).format("MMM D, YYYY h:mm A")
                  : "Not Available"}
              </Typography.Text>
            </div>
          </Col>
        </Row>

        {user?.permitted_customers === "ALL" && (
          <div className="profile-super-user">
            <CheckCircleOutlined className="super-user-icon" />
            <span className="super-user-text">Super User</span>
          </div>
        )}
      </Space>
    </Modal>
  );
};

export default ProfilePopup;
